import useLocale from "@Hooks/selector/useLocale";
import useCurrency from "@Currency/hooks/useCurrency";
import Time, {TimeProps} from "@DateTime/components/Time";

type TimeWithRegionalFormatProps = Omit<TimeProps, 'format'>

function TimeWithRegionalFormat({time, className}: TimeWithRegionalFormatProps) {
    const locale = useLocale()
    const currency = useCurrency()
    const hourFormat = (locale === 'en-us' || currency?.val === 'USD') ? 'H aa' : 'HH:mm'

    return (
        <Time
            time={time}
            format={hourFormat}
            className={className}
        />
    );
}

export default TimeWithRegionalFormat;